import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class Pc003Service extends BaseService<any> {

    pc003Api: string = environment.api_adm + 'v1/pc003';

    constructor(http: HttpClient) { super(http); }

    async getListPc003(filter) {
        var fullUri = this.pc003Api + `/list`;
        if (filter) {
            fullUri += "?" + this.builderFilter(filter)
        }

        return await this.http.get<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }
    async remove(ids) {
        const fullUri = this.pc003Api + `/deleteByIds`;

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: { ids: ids },
        };

        return await this.http.delete<any>(fullUri, options).toPromise();
    }



    async importFile(file) {

        const fullUri = this.pc003Api + `/csv/import`;
        return await this.http.post(fullUri, file, { headers: this.getOptionsFile() }).toPromise();
    }
    async getPc003ById(id) {
        const fullUri = this.pc003Api + `/getById/${id}`;
        return await this.http.get<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }
    async updatePc003(data) {
        const fullUri = this.pc003Api + `/update`;
        return await this.http.put(fullUri, data, { headers: this.getOptions() }).toPromise();
    }
    async addPc003(data) {
        const fullUri = this.pc003Api + `/create`;
        return await this.http.post(fullUri, data, { headers: this.getOptions() }).toPromise();
    }

    builderFilter(filter) {
        var filterQuery = ""
        var isFirst = true;
        if (filter.ano) {
            filterQuery += `ano=${filter.ano}`
            isFirst = false;
        }
        if (filter.contrato_juridico) {
            filterQuery += `${isFirst ? "" : "&"}contrato_juridico=${filter.contrato_juridico}`
            isFirst = false;
        }
        if (filter.hibrido_rnc) {
            filterQuery += `${isFirst ? "" : "&"}hibrido_rnc=${filter.hibrido_rnc}`
            isFirst = false;
        }
        if (filter.especie) {
            filterQuery += `${isFirst ? "" : "&"}especie=${filter.especie}`
            isFirst = false;
        }
        if (filter.safra) {
            filterQuery += `${isFirst ? "" : "&"}safra=${filter.safra}`
            isFirst = false;
        }
        if (filter.geracao) {
            filterQuery += `${isFirst ? "" : "&"}geracao=${filter.geracao}`
            isFirst = false;
        }
        if (filter.site_origem) {
            filterQuery += `${isFirst ? "" : "&"}site_origem=${filter.site_origem}`
            isFirst = false;
        }

        return filterQuery;
    }


    saveCommentPc003(data): Observable<any> {
        // tslint:disable-next-line: max-line-length
        if (data.id != null) {

            return this.http.put<any>(`${this.pc003Api}/comment`, data, { headers: this.getOptions() });
        }

        return this.http.post<any>(`${this.pc003Api}/comment`, data, { headers: this.getOptions() });
    }

    deleteCommentPc003(id) {
        return this.http.delete<any>(`${this.pc003Api}/comment/${id}`, { headers: this.getOptions() });
    }
}